'use strict';

namespace Core {
    function factory(template) {
        return function() {
            return {
                scope: true,
                bindToController: {
                    message: '@'
                },
                restrict: 'E',
                controller: 'DiscountMessage',
                controllerAs: 'dm',
                template: template,
                replace: true
            };
        };
    }

    const messageTemplate = `
        <div class="hype-message hype-message-discount">
            {{::dm.message}}
        </div>`;

    class DiscountMessage {
        message: string;
    }

    angular.module('core')
        .controller('DiscountMessage', DiscountMessage)
        .directive('discountMessage', factory(messageTemplate));
}
